import { unit } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: ${unit('xl')} 0;
`;
